import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import './fonts/montserrat/montserrat.css';
import './index.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import store, { history } from './store';

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js